import getFeatureFlag from "@/shared/lib/getFeatureFlag";

// Not VUE_APP_CLIENT_BASE_URL: this app's render of properties.json points that
// key at the legacy portal.
const VUE3_CLIENT_BASE_URL_KEY = "VUE_APP_VUE3_CLIENT_BASE_URL";
const LEGACY_PORTAL_FEATURE_FLAG = "canAccessLegacyAmplify";

function vue3ClientUrl(runtimeConfig, path) {
  const baseUrl = runtimeConfig.get(VUE3_CLIENT_BASE_URL_KEY);
  return baseUrl ? baseUrl + path : null;
}

export function getVue3ClientLoginUrl(runtimeConfig) {
  return vue3ClientUrl(runtimeConfig, "/login");
}

export function getVue3ClientCreateAccountUrl(runtimeConfig) {
  return vue3ClientUrl(runtimeConfig, "/create-account");
}

// Checked per user through the signed-in authToken cookie. A failed check
// counts as not flagged, so the client still lands on the new site.
export async function canAccessLegacyAmplify() {
  try {
    return (await getFeatureFlag(LEGACY_PORTAL_FEATURE_FLAG)) === true;
  } catch {
    return false;
  }
}

// Vue 3 adopts the session from the authToken cookie, so the token never travels
// in the URL, and routes clients without an account to setup itself. Null for a
// client flagged for the legacy portal, when the Vue 3 URL is missing, or when it
// is this page's own host: then this app isn't Vue 3, and going there would only
// reload it, in a loop.
export async function getNewPortalHandoffUrl(
  runtimeConfig,
  currentHost = window.location.host
) {
  const handoffUrl = vue3ClientUrl(runtimeConfig, "/login/handoff");
  if (!handoffUrl || new URL(handoffUrl).host === currentHost) return null;
  if (await canAccessLegacyAmplify()) return null;
  return handoffUrl;
}

// Where a client signed in on a penchecks.com site goes. Only the legacy portal
// uses the login response's user, to route one without an account to setup.
export async function getClientPortalUrl(runtimeConfig, user) {
  const handoffUrl = await getNewPortalHandoffUrl(runtimeConfig);
  if (handoffUrl) return handoffUrl;

  const legacyUrl = runtimeConfig.get("VUE_APP_CLIENT_BASE_URL");
  const hasNoAccount =
    user &&
    !(user.clientMasterAccounts && user.clientMasterAccounts.length > 0);
  return hasNoAccount ? legacyUrl + "/account-creation" : legacyUrl;
}

export async function goToClientPortal(runtimeConfig, user) {
  document.location = await getClientPortalUrl(runtimeConfig, user);
}

// For sites outside penchecks.com, which can't set the penchecks.com session
// cookie: the client signs in on the auth site, where the flag is checked.
export function getClientPortalLoginUrl(runtimeConfig) {
  return runtimeConfig.get("VUE_APP_LOGIN_URL");
}
